/**
 * UserManagementDialog Component
 * Dialog wrapper for the UserManagement component
 * Extracted from App.js to reduce main file complexity
 */
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from '@/components/ui/dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import UserManagement from '@/components/admin/UserManagement';

const UserManagementDialog = ({
  isOpen,
  onClose
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl max-h-[80vh] overflow-auto">
        <VisuallyHidden>
          <DialogTitle>Gestión de Usuarios</DialogTitle>
        </VisuallyHidden>
        <UserManagement />
      </DialogContent>
    </Dialog>
  );
};

export default UserManagementDialog;
